import { useEffect } from 'react';
import { clarity } from 'react-microsoft-clarity';

// Keep the raw Auth0 subject out of Clarity. This remains a pseudonymous identifier.
export const getClarityUserId = async (userId) => {
  const input = new TextEncoder().encode(`questri:clarity:user:v1:${userId}`);
  const digest = await window.crypto.subtle.digest('SHA-256', input);
  const encoded = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `questri-user-${encoded}`;
};

const useClarityUser = ({
  isAuthenticated,
  isLoadingAuth0,
  userId,
  pathname,
}) => {
  useEffect(() => {
    let cancelled = false;
    const identify = async () => {
      if (isLoadingAuth0 || !isAuthenticated || typeof userId !== 'string' || !userId.trim()) {
        return;
      }

      try {
        if (clarity.hasStarted()) {
          const clarityUserId = await getClarityUserId(userId);
          if (!cancelled) {
            // The next argument is a custom session ID, not a user properties object.
            clarity.identify(clarityUserId);
          }
        }
      } catch (error) {
        // Optional analytics must not interrupt login or navigation.
      }
    };

    identify();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, isLoadingAuth0, userId, pathname]);
};

export default useClarityUser;
